import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarkedAlt } from '@fortawesome/free-solid-svg-icons';
import { Button, Tooltip } from 'antd';

type MapMarkedIconButtonProps = {
  active?: boolean;
  onClick?: () => void;
  disabled?: boolean;
  messageDisabled?: string;
};

const MapMarkedIconButton = ({
  active,
  onClick,
  disabled,
  messageDisabled,
}: MapMarkedIconButtonProps) => {
  return (
    <Tooltip placement="top" title={disabled ? messageDisabled || '' : ''}>
      <Button
        icon={
          <StyledFontAwesomeIcon
            active={active}
            icon={faMapMarkedAlt}
            size="sm"
          />
        }
        type="text"
        shape="circle"
        size="small"
        onClick={(event) => {
          event.stopPropagation();
          onClick?.();
        }}
        disabled={disabled}
      />
    </Tooltip>
  );
};

export { MapMarkedIconButton };

const StyledFontAwesomeIcon = styled((props) => <FontAwesomeIcon {...props} />)`
  color: ${({ active }) => (active ? 'var(--primary-color)' : '#AEAEAE')};
`;
